module.exports = __webpack_public_path__ + "img/card-video.816f59c7.gif";